import { useMe } from "@/data/user";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import StaticNotificationItem from "./StaticNotificationItem";

/* eslint-disable react-refresh/only-export-components */
export default () => {
  const { t } = useTranslation();
  const { me } = useMe();
  const navigate = useNavigate();

  const user = me?.item;

  let kickoffDateObj: Date | dayjs.Dayjs = new Date();

  if (user?.date_active_book_exam) {
    kickoffDateObj = new Date(user.date_active_book_exam);
  } else if (user?.end_kickoff_date) {
    kickoffDateObj = dayjs(user.end_kickoff_date);
    kickoffDateObj = kickoffDateObj.subtract(
      (user?.subDaysBookExam ? Number(user?.subDaysBookExam) : 30) ?? 30,
      "days",
    );
    kickoffDateObj = new Date(kickoffDateObj.format("YYYY-MM-DD"));
  }

  let lang: string = "en-US";
  switch (user?.user.lang) {
    case "it":
      lang = "en-US";
      break;
    case "es":
      lang = "es-ES";
      break;
    case "de":
      lang = "de-DE";
      break;
    case "fr":
      lang = "fr-FR";
      break;
    case "pt":
      lang = "pt-PT";
      break;
    default:
      lang = "en-US";
      break;
  }

  const deadline = kickoffDateObj.toLocaleDateString(lang, {
    day: "numeric",
    month: "short",
  });

  if (
    !user?.user?.crm_upselling?.meetings?.meet?.[0]?.start &&
    dayjs(kickoffDateObj).subtract(14, "days") <= dayjs() &&
    dayjs() <= dayjs(kickoffDateObj) &&
    user?.hasIelts
  ) {
    return (
      <StaticNotificationItem
        text={
          <>
            {t("home.static_notifications.book_exam_1")} <b>{deadline}</b>{" "}
            {t("home.static_notifications.book_exam_2")}
          </>
        }
        color="text-black"
        border="border-none"
        buttonText="Book exam"
        background="bg-white"
        buttonColor="text-[--secondary]"
        borderButton="border-[1px]"
        handleComplete={() =>
          navigate("/user/dashboard/book-exam", { replace: true })
        }
        buttonBackground="bg-white"
      />
    );
  }

  return null;
};
